import { cn } from '@app/utils/cn';
import React from 'react';

interface Props {
  id?: string;
  role: 'menu' | 'listbox';
  className?: string;
  onKeyDown?: (event: React.KeyboardEvent) => void;
}

export const Menu = ({ id, role, children, className, onKeyDown }: React.PropsWithChildren<Props>) => {
  return (
    <div id={id} role={role} className={cn('flex flex-col gap-1', className)} onKeyDown={onKeyDown}>
      {children}
    </div>
  );
};
